import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { BusinessEntity } from "@/stores/business-entities-store";
import EntityEditor from "@/components/entities/EntityEditor.vue";
import { useHotKeys } from "./hotkeys";

export const useEditEntityDialog = (
    opts: {
        withHotKey: boolean;
    } = {
        withHotKey: true,
    }
) => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    if (opts.withHotKey) {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n d",
            (e) => {
                if (!isVisible.value) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new definition dialog."
        );
    }

    const open = (entity?: BusinessEntity) => {
        dialogRef.value = dialog.open(EntityEditor, {
            props: {
                header: entity ? "Edit definition" : "New definition",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: entity,
        });
    };

    return {
        open,
        isVisible: computed(() => Boolean(dialogRef.value?.visible)),
    };
};
